import { FC } from "react";
import { NotFoundContent } from "../NotFoundContent";
import { AlertTriangle } from "lucide-react";

interface ErrorContentProps {
	error: ApiError;
	message?: string;
	notFoundMessage?: string;
	maxWidth?: number;
}

export const ErrorContent: FC<ErrorContentProps> = ({
	error,
	notFoundMessage = "No data found",
	message = "Unable to load data",
}) => {
	if (error.status === 404) {
		return <NotFoundContent message={notFoundMessage} />;
	}

	return (
		<div className="w-full" aria-live="polite" aria-atomic="true">
			<div className="flex gap-3 items-start rounded-md  bg-red-50 border-red-200/80 px-3 py-3 w-full">
				<AlertTriangle className="h-4 w-4 mt-0.5 text-red-600 shrink-0" />
				<div className="flex-1 min-w-0">
					<div className="text-sm font-medium text-red-700">{message}</div>

					{error.message && (
						<details className="mt-1 group">
							<summary className="text-xs text-red-600/80 hover:text-red-700 cursor-pointer underline decoration-dotted">
								Show details
							</summary>
							<pre className="mt-1 max-h-28 overflow-auto whitespace-pre-wrap text-[11px] leading-snug text-red-700/90 bg-red-100/60 rounded p-2 border border-red-200/70 w-full">
								{error.message}
							</pre>
						</details>
					)}
				</div>
			</div>
		</div>
	);
};
